"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class CalendarIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M3,3 L21,3 L21,21 L3,21 L3,3 Z M4,7 L4,20 L20,20 L20,7 L4,7 Z" }),
                    React.createElement("rect", { x: "17", y: "8", width: "2", height: "2" }),
                    React.createElement("rect", { x: "14", y: "8", width: "2", height: "2" }),
                    React.createElement("rect", { x: "11", y: "8", width: "2", height: "2" }),
                    React.createElement("rect", { x: "8", y: "8", width: "2", height: "2" }),
                    React.createElement("rect", { x: "17", y: "11", width: "2", height: "2" }),
                    React.createElement("rect", { x: "14", y: "11", width: "2", height: "2" }),
                    React.createElement("rect", { x: "11", y: "11", width: "2", height: "2" }),
                    React.createElement("rect", { x: "8", y: "11", width: "2", height: "2" }),
                    React.createElement("rect", { x: "17", y: "14", width: "2", height: "2" }),
                    React.createElement("rect", { x: "14", y: "14", width: "2", height: "2" }),
                    React.createElement("rect", { x: "11", y: "14", width: "2", height: "2" }),
                    React.createElement("rect", { x: "8", y: "14", width: "2", height: "2" }),
                    React.createElement("rect", { x: "11", y: "17", width: "2", height: "2" }),
                    React.createElement("rect", { x: "8", y: "17", width: "2", height: "2" }),
                    React.createElement("rect", { x: "5", y: "11", width: "2", height: "2" }),
                    React.createElement("rect", { x: "5", y: "14", width: "2", height: "2" }),
                    React.createElement("rect", { x: "5", y: "17", width: "2", height: "2" })))));
    }
}
exports.CalendarIcon = CalendarIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/calendar.tsx
// module id = 2129
// module chunks = 0 1 2